import { useEffect, useState } from 'react';

import { getMobileOS, type MobileOS } from '../utils/platform';

/**
 * React-friendly wrapper around {@link getMobileOS}.
 *
 * Detection is deferred to a `useEffect` so the first render is always
 * `'unknown'`. That keeps the value stable for any future SSR / prerender
 * snapshot (which would otherwise capture a desktop `'other'` and cause a
 * hydration mismatch) and lets callers avoid flashing the wrong banner: they
 * render nothing until the OS is resolved on the client.
 */
export function useMobileOS(): MobileOS | 'unknown' {
  const [os, setOs] = useState<MobileOS | 'unknown'>('unknown');

  useEffect(() => {
    setOs(getMobileOS());
  }, []);

  return os;
}
